/**
 * Motion building blocks. Each reads the active design's presets (src/designs/<id>/index.ts),
 * so the same page moves like Storybook or like Nebula without changing a line.
 */
export { DrawPath } from './DrawPath';
export { Lift, type LiftProps } from './Lift';
export { Float, Loop, type LoopPreset } from './Loop';
export { BlurIn, ClipUp, Reveal, type RevealEffect, type RevealProps } from './Reveal';
export { useDesignMotion } from './useDesignMotion';
